export default __webpack_public_path__ + "static/media/ITALogoDark@3x.0e868450.png";